import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  inputWrapper: {
    display: 'flex',
    width: '100%',
    position: 'relative',
  },

  panels: {
    marginTop: theme.spacing(1.2),
    width: '100%',

    '& option': {
      height: '100px',
    },
  },

}));

export default useStyles;
